"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function asPlainObjectOrThrow(value, error) {
    if (!value || Array.isArray(value) || typeof value !== "object") {
        throw error;
    }
    return value;
}
exports.default = asPlainObjectOrThrow;
//# sourceMappingURL=asPlainObjectOrThrow.js.map